export const qualityES = {
  one: '¿Cómo calificarías está llamada?',
  two: '¿Qué tal calificarías tú profesor?',
  success: '¡Gracias por tu calificación!',
  error: 'Hubo un problema con la calificación.'
}
